var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLamp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3h6l2 7H7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 10v7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9 17h6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 21h8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 17l-1 4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 17l1 4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLamp);
export default __webpack_public_path__ + "static/media/lamp.c2248c96556f4b534b7b13014590cfc8.svg";
export { ForwardRef as ReactComponent };